export const logo: any = {
    '178': 'bnp-logo_Green',
    'dsp blackrock mutual fund': 'DSP',
    H: 'HDFC',
    O: 'HSBC',
    P: 'ICICI',
    G: 'bandhan-02',
    K: 'KOTAK',
    L: 'SBI',
    '176': 'SundaramMutualLogo',
    T: 'TATA',
    AO: 'angel_one',
    '101': 'canara_robeco',
    '139': 'oldbridge_v2',
    '102': 'lic',
    '103': 'principalmf',
    TMF: 'Taurus_Logo',
    '105': 'jmf',
    '107': 'bp',
    '108': 'uti',
    '113': 'sahara',
    '116': 'boi_axa',
    '117': 'mirae',
    '118': 'edel',
    '120': 'Invesco',
    '121': '', //crayon
    '123': 'quantum',
    '124': '', // vistaar religare mutual fund
    '125': 'groww_new',
    '127': 'mo',
    '128': 'axis',
    '129': 'PGIMamc',
    // '130': 'navi_mutual_fund', //peerless mutual fund
    PLF: 'navi_mf_logo',
    '135': 'idbimflogo',
    '152': 'itimf_logo',
    '166': 'quant',
    '185': 'trust',
    RMF: 'rel',
    'aig mutual fund': '',
    'birla sun life mutual fund': '',
    'dbs chola mutual fund': '',
    'fidelity mutual fund': '',
    'ing mutual fund': '',
    'fortis mutual fund': '',
    'sundaram bnp paribas mutual fund': '',
    B: 'aditya_v2',
    IF: 'IIFL_v2',
    F: 'L&T',
    MM: 'MahindraManulife',
    PP: 'PPFAS',
    SH: 'Shriram',
    UK: 'Union_2',
    Y: 'YES',
    D: 'DSP',
    FTI: 'franklin',
    '187': 'njam',
    '188': 'samco',
    '189': 'bajaj-new',
    HLS: 'Helios',
    UFI: 'unifi',
    Z: 'zerodha',
    JIO: 'jio',
    183: 'cm',
    174: 'wealth',
    CHS: 'choice',
};

export const favLogos: any = {
    183: 'cm_MF',
    '178': 'bnp_MF',
    'dsp blackrock mutual fund': 'DSP',
    H: 'hdfc_MF',
    O: 'hsbc_MF',
    P: 'icici_MF',
    G: 'bandhan-25-02',
    K: 'kotak_MF',
    L: 'sbi_MF',
    '176': 'sundaram_MF',
    T: 'tata_MF',
    '101': 'canara_MF',
    '102': 'lic_MF',
    '103': 'principalmf',
    TMF: 'Taurus_Logo_SVG',
    AO: 'angel_one_MF',
    '105': 'jm_MF',
    '107': 'baroda_MF',
    '108': 'uti_MF',
    '113': 'sahara',
    '116': 'boi_MF',
    '117': 'mirae_MF',
    '118': 'edelweiss_MF',
    '120': 'invesco_MF',
    // '121': '', //crayon
    '123': 'quantum_MF',
    // '124': '', // vistaar religare mutual fund
    '125': 'groww_new',
    '127': 'motilal_MF',
    '128': 'axis_MF',
    '129': 'PGIM_India_MF',
    // '130': 'navi_MF', //peerless mutual fund
    PLF: 'navi_mf_new',
    '135': 'idbi_MF',
    '152': 'iti_MF',
    '166': 'quant_MF',
    '185': 'trust_MF',
    RMF: 'nippon_MF',
    // 'aig mutual fund': '',
    // 'birla sun life mutual fund': '',
    // 'dbs chola mutual fund': '',
    // 'fidelity mutual fund': '',
    // 'ing mutual fund': '',
    // 'fortis mutual fund': '',
    // 'sundaram bnp paribas mutual fund': '',
    B: 'aditya_v2',
    IF: 'iifl_MF_v2',
    F: 'lnt_MF',
    MM: 'mahindra_MF',
    PP: 'ppfas_MF',
    SH: 'shriram_MF',
    UK: 'Union_MF_2',
    Y: 'white_MF',
    UFI: 'unifi_MF',
    D: 'dsp_MF',
    FTI: 'franklin_MF',
    '188': 'samco_MF',
    '189': 'bajaj-new',
    '189-exception': 'bajaj-exc',
    '187': 'NJ_MF',
    HLS: 'Helios',
    Z: 'zerodha',
    '139': 'old_bridge_mf_v2',
    JIO: 'jio_MF',
    174: 'wealth_MF',
    CHS: 'choice_MF',
};

//birla sunlife mutual fund and aditya birla are they same

//navi
